import QRCode from 'qrcode'
import Clipboard from "clipboard";
// 文本多行展开收起组件
Vue.component("share_popover_btn", {
  props: {
    course_name: ''
  },
  data() {
    return {
      qrcodeUrl: '',
    };
  },
  methods: {
    init() {
      const that = this
      this.$nextTick(() => {
        let shareUrl = location.origin + location.pathname
        //生成分享二维码
        QRCode.toDataURL(shareUrl, {
          width: 90,
          height: 90,
          margin: 0,
          errorCorrectionLevel: 'L', //纠错级别
        }).then(url => {
          that.qrcodeUrl = url
        });
        //复制剪切板初始化
        var clipboard = new Clipboard(this.$refs.copy_link_btn, {
          text: () => '《' + that.course_name + '》\n' + shareUrl
        })

        clipboard.on('success', function (e) {
          that.$message.success('复制成功')
          e.clearSelection();
        });
      })
    }
  },
  mounted() {
    this.init();
  },
  template: `
      <el-popover
      class="share_popover_btn"
      placement="bottom"
      width="160"
      trigger="click">
        <div class="share_popover_content">
          <div id="shareQrcode">
            <img :src="qrcodeUrl" />
          </div>
          <p>{{$t('用微信、QQ扫描分享')}}</p>
          <a ref="copy_link_btn">{{$t('复制链接')}}</a>
        </div>
        <div class="share" slot="reference">
          <iconfont type="iconrizhi"></iconfont>
          <span>{{$t('分享')}}</span>
        </div>
      </el-popover>
  `,
});